// extracted by mini-css-extract-plugin
export default {"notes-list":"NotesList_notes-list__Bq2H8","ListItem":"NotesList_ListItem__AEMhG"};